import React from 'react';
import memoize from 'memoize-one';
import { ButtonTooltip, Icon } from '../../components';

const columns = memoize(clickHandler => [
  {
    name: 'RUT',
    selector: 'national_identification',
    sortable: true,
    grow: '2',
    wrap: true
  },
  {
    name: 'NOMBRE',
    selector: 'full_name',
    sortable: true,
    grow: '2',
    wrap: true
  },
  {
    name: 'CENTRO DE COSTO',
    selector: 'cost_center',
    sortable: true,
    grow: '2',
    wrap: true
  },
  {
    name: 'AREA',
    selector: 'job_management',
    sortable: true,
    grow: '2',
    wrap: true
  },
  {
    name: 'CONCEPTO',
    selector: 'balance_name',
    sortable: true,
    grow: '2',
    wrap: true
  },
  {
    name: 'ORIGEN',
    selector: 'source_type',
    sortable: true,
    grow: '2',
    wrap: true
  },
  {
    name: 'MONTO',
    selector: 'parsed_amount',
    sortable: true,
    grow: '2',
    wrap: true,
    center: true
  },
  {
    name: 'ESTADO',
    selector: 'data_process_status',
    grow: '2',
    wrap: true
  },
  {
    name: 'ACCIONES',
    cell: item => {
      return (
        <>
          <ButtonTooltip
            variant="circle-primary"
            className="btn-circle"
            onClick={() => clickHandler(item, 'payment_document')}
            text="Generar documento"
            disabled={item.source_type === 'Solicitudes'}
          >
            <Icon icon="document-text" />
          </ButtonTooltip>
        </>
      );
    },
    grow: '1'
  }
]);

export default columns;
